<template>
	<b-container fluid>
		<b-row>
			<b-col>
				<h5 class="text-center">Announcements</h5>
			</b-col>
		</b-row>
		<b-row v-if="isAdmin" class="text-right">
			<b-col>
				<b-button variant="success" v-b-modal="'newAnnouncementModal'">
					<b-icon icon="plus-square"></b-icon>
				</b-button>
			</b-col>
		</b-row>
		<div v-if="status === 'loading'" class="text-center my-3">
			<b-row class="text-center my-3">
				<b-col>
					<b-spinner></b-spinner>
				</b-col>
			</b-row>
		</div>
		<div v-else-if="status === 'error'" class="text-center my-3">
			<b-row class="text-center my-3">
				<b-col>
					<b-icon icon="x" variant="danger"></b-icon>
				</b-col>
			</b-row>
		</div>
		<div v-else-if="status === 'fetched' && announcements.length">
			<b-row class="text-left my-3">
				<b-col>
					<b-card
						v-for="(announcement, index) in announcements"
						:key="index"
						:title="announcement.title"
						:sub-title="new Date(announcement.date).toString().substr(0, 15)"
						class="announcement"
					>
						<b-card-text class='text-left'><p style="white-space: pre-line">{{ announcement.text }}</p></b-card-text>
						<b-button
							v-if="isAdmin"
							variant="outline-danger"
							@click="deleteAnnouncement(announcement.id)"
						>Delete</b-button>
					</b-card>
				</b-col>
			</b-row>
		</div>
		<div v-else>
			<b-row class="text-center my-3">
				<b-col>
					<span class="text-secondary">No announcements</span>
				</b-col>
			</b-row>
		</div>

		<b-modal
			id="newAnnouncementModal"
			title="New Announcement"
			size="lg"
			ok-title="Create Announcement"
			:ok-disabled="!this.newAnnouncement.date.length || !this.newAnnouncement.title.length || !this.newAnnouncement.text.length"
			@ok="createAnnouncement"
		>
			<b-container fluid>
				<b-row class="my-2">
					<b-col>
						<strong>Date</strong>
						<b-form-datepicker v-model="newAnnouncement.date" class="text-center"></b-form-datepicker>
					</b-col>
				</b-row>

				<b-row class="my-2">
					<b-col>
						<strong>Title</strong>
						<b-form-input v-model="newAnnouncement.title" class="text-center"></b-form-input>
					</b-col>
				</b-row>

				<b-row class="my-2">
					<b-col>
						<strong>Text</strong>
						<b-form-textarea v-model="newAnnouncement.text"></b-form-textarea>
					</b-col>
				</b-row>
			</b-container>
		</b-modal>
	</b-container>
</template>

<script>
export default {
	name: "Announcements",
	data() {
		return {
			status: "loading",
			announcements: [],
			newAnnouncement: {
				date: new Date().toISOString().substring(0, 10),
				title: "",
				text: "",
			},
		}
	},
	computed: {
		isAdmin() {
			return this.$store.getters.isAdmin
		},
	},
	methods: {
		getAnnouncements: function() {
			return new Promise((resolve, reject) => {
				fetch(this.$apiURL + "/getAnnouncements", {
					method: "GET",
					headers: new Headers({
						Authorization: this.$store.state.token,
						"Content-Type": "application/json",
					}),
				}).then(res => {
					if (res.ok) {
						res.json().then(announcements => {
							this.announcements = announcements
							this.status = "fetched"
							resolve()
						})
					} else {
						this.status = "error"
						reject()
					}
				})
			})
		},
		createAnnouncement: function() {
			return new Promise((resolve, reject) => {
				fetch(this.$apiURL + "/createAnnouncement", {
					method: "POST",
					headers: new Headers({
						Authorization: this.$store.state.token,
						"Content-Type": "application/json",
					}),
					body: JSON.stringify({
						date: this.newAnnouncement.date,
						title: this.newAnnouncement.title,
						text: this.newAnnouncement.text,
					}),
				}).then(res => {
					if (res.ok) {
						this.getAnnouncements().then(() => {
							alert("Announcement created.")
							this.newAnnouncement.date = ""
							this.newAnnouncement.title = ""
							this.newAnnouncement.text = ""
							resolve()
						})
					} else {
						alert("Error creating announcement. Try again.")
						reject()
					}
				})
			})
		},
		deleteAnnouncement: function(id) {
			if (confirm("Delete announcement?")) {
				return new Promise((resolve, reject) => {
					fetch(this.$apiURL + "/deleteAnnouncement", {
						method: "POST",
						headers: new Headers({
							Authorization: this.$store.state.token,
							"Content-Type": "application/json",
						}),
						body: JSON.stringify({
							id: id,
						}),
					}).then(res => {
						if (res.ok) {
							this.getAnnouncements().then(() => {
								alert("Announcement deleted.")
								resolve()
							})
						} else {
							alert("Error deleting announcement. Try again.")
							reject()
						}
					})
				})
			}
		},
	},
	async created() {
		await this.getAnnouncements()
	},
}
</script>

<style scoped>
strong {
	display: block;
	text-align: center;
}

.announcement {
	margin: 10px auto;
	max-width: 500px;
}
</style>
